var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_svg__doNotFill",
    d: "M15.918.575H4.082A4.082 4.082 0 000 4.657v11.837a4.082 4.082 0 004.082 4.081h11.836A4.082 4.082 0 0020 16.494V4.657A4.082 4.082 0 0015.918.575z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 .575H0v20h20v-20z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon_svg__doNotFill",
    d: "M15.864 9.075l-1.668-3.954-3.906 2.071.593 1.12 1.862-.987-.837 2.465c-.002.007-.243.714-.583 1.453-.223.484-.41.813-.557 1.034-.294.377-.402.026-.402.026v.001a4.083 4.083 0 01-.05-.171c-.308-1.145-.847-2.676-1.969-2.744-1.275-.077-2.114 1.731-2.863 3.59a10.06 10.06 0 01-.182.436c-.547 1.123-1.005 1.449-1.01 1.451 0 0-.521.374-.17.875.35.5.844.199.844.199.122-.075.768-.52 1.475-1.97.055-.114.124-.283.218-.518.197-.489.495-1.227.841-1.845.16-.283.296-.483.408-.623.042-.05.356-.395.67.07.144.263.323.697.514 1.408.1.37.402 1.493 1.317 1.522h.035c.674 0 1.276-.627 1.946-2.027.415-.868.706-1.724.718-1.76l.826-2.436.762 1.806 1.168-.492z",
    fill: "#fff"
  }))));
}
export default SvgIcon;